import type { SliceSummary } from '../../types/weekly'
import type { RailPick } from '.'

// The slices as a rail: pipeline, accounts, people, tactics, meetings, with how much moved in each and which way.
// Click to read that slice's cards; the top item reads everything in order.
export function MovementRail({ slices, total, current, onPick }: { slices: SliceSummary[]; total: number; current: RailPick; onPick: (p: RailPick) => void }) {
  const max = Math.max(1, ...slices.map((s) => s.count))
  return (
    <nav className="scenario-rail movement-rail" aria-label="Movement">
      <button className={`rail-item all ${current === 'all' ? 'active' : ''}`} onClick={() => onPick('all')}>
        <span className="rail-label">Everything that moved</span>
        <span className="rail-count">{total.toLocaleString()}</span>
      </button>
      <p className="rail-title">By slice</p>
      {slices.map((s) => (
        <button key={s.slice} className={`rail-item ${current === s.slice ? 'active' : ''}`} onClick={() => onPick(s.slice)} title={`${s.title}: ${s.count} moved, ${s.ups} up, ${s.downs} down${s.shown < s.count ? `; the ${s.shown} strongest carry a card` : ''}`}>
          <span className="rail-label">{s.title}</span>
          <span className="rail-bar"><span style={{ width: `${(s.count / max) * 100}%` }} /></span>
          <span className="rail-meta">
            <span className="rail-count">{s.count}</span>
            {s.ups > 0 && <span className="rail-dot ok" title={`${s.ups} up`} />}
            {s.ups > 0 && <span className="rail-n">{s.ups}</span>}
            {s.downs > 0 && <span className="rail-dot low" title={`${s.downs} down`} />}
            {s.downs > 0 && <span className="rail-n">{s.downs}</span>}
          </span>
        </button>
      ))}
    </nav>
  )
}
